import { useEffect } from "react";
import { useAuthStateContext } from "/src/features/auth/context/authContext";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import NotFound from "./NotFound";
import { useNavigate } from "react-router-dom";
import Loader from '/src/components/loader/Loader';
function RedirectHomeOrNotFound() {

    const naviguate = useNavigate();
    const { user, fetching, error } = useAuthStateContext();
    useEffect(() => {
        if(!user) {
            return;
        }

        naviguate(urlWithRoutingCompany('home'))
    }, [user])
    return <>
        { fetching == true ? <Loader/> : null}
        { error == true ? <NotFound/> : null }
    </>  
}

export default RedirectHomeOrNotFound;